<template>
    <v-row
        align="start"
        justify="center"
        class="d-flex flex-row justify-center"
    >
        <v-col
            cols="12"
            md="11"
            justify="center"
            class="pt-0"
        >
            <v-row>
                <v-col cols="12">
                    <v-card>
                        <!-- Search -->
                        <v-card-title>
                            <v-text-field
                                v-model="search"
                                append-icon="fas fa-search"
                                label="Search Media Library"
                                single-line
                                hide-details
                                outlined
                                dense
                            />
                        </v-card-title>

                        <!-- Library Index Table -->
                        <v-data-table
                            :items="files"
                            :headers="headers"
                            :loading="tableLoading"
                            :search="search"
                        >
                            <template #item.filename="{ item }">
                                {{ item.filename }}.{{ item.extension }}
                            </template>

                            <template #item.src="{ item }">
                                <v-img
                                    height="100"
                                    width="250"
                                    :src="itemSource(item)"
                                    cover
                                >
                                    <template #placeholder>
                                        <v-row
                                            class="fill-height ma-0"
                                            align="center"
                                            justify="center"
                                        >
                                            <v-progress-circular
                                                indeterminate
                                                color="primary"
                                            />
                                        </v-row>
                                    </template>
                                </v-img>
                            </template>

                            <template #item.directory="{ item }">
                                {{ determineDirectory(item.directory) }}
                            </template>

                            <template #top="{ pagination, options, updateOptions }">
                                <v-data-footer
                                    :pagination="pagination"
                                    :options="options"
                                    @update:options="updateOptions"
                                    items-per-page-text="$vuetify.dataTable.itemsPerPageText"
                                />
                            </template>

                            <template #item.id="{ item }">
                                <v-btn
                                    icon
                                    small
                                    @click="initEdit(item.id, item.fields, item.src, item.professions)"
                                >
                                    <v-icon small>
                                        fas fa-edit
                                    </v-icon>
                                </v-btn>
                                <v-btn
                                    icon
                                    small
                                    @click="initDelete(item.id, item.filename, item.extension)"
                                >
                                    <v-icon small>
                                        fas fa-trash
                                    </v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import { mapState } from 'vuex';
import store from '@/store/store';
import MediaCrudMixin from '@/views/Admin/MediaLibrary/MediaCrudMixin';

export default {
    mixins: [ MediaCrudMixin ],

    computed: {
        ...mapState('mediaLibrary', ['files', 'tableLoading']),

        deleteModal: {
            get: function() {
                return store.state.mediaLibrary.deleteModal;
            },
            set: function(value) {
                this.toggleDeleteModal(value);
            }
        }
    },

    data() {
        return {
            search: '',
            headers: [
                {
                    text: '',
                    value: 'src',
                    sortable: false,
                    filterable: true,
                    width: 200
                },
                {
                    text: 'Name',
                    value: 'filename',
                    width: 400
                },
                {
                    text: "Type",
                    value: 'aggregate_type',
                },
                {
                    text: 'Actions',
                    value: 'id',
                    align: 'right',
                    sortable: false,
                    filterable: false
                }
            ]
        };
    },

    methods: {
        // Here and not in the edit modal to prevent having potentially hundreds of edit modals rendered.
        initEdit(id, dir, src, professions) {
            this.setCurrentSrc(src);
            this.setSelectedFields(dir);
            this.setProfession(this.getProfessionIds(professions));
            this.setMediaId(id)
                .then(() => {
                    this.toggleEditModal(true);
                });
        },

        initDelete(id, filename, extension) {
            this.setDeleteFilename(filename+'.'+extension);

            this.setMediaId(id)
                .then(() => {
                    this.toggleDeleteModal(true);
                });
        },

        determineDirectory(dir) {
            return dir.substring(dir.lastIndexOf('/') + 1, dir.length);
        },

        itemSource(item) {
            if (item.extension === 'pdf') {
                return this.$storageURL + 'placeholder/pdf-placeholder.jpg';
            } else {
                return item.src;
            }
        }
    }
};
</script>
